import script from "./sf-static-pill.ce.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-static-pill.ce.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__